import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ClinicTabContainer from "../modules/ClinicTabContainer";
import clinicService from "../../../services/clinic.service";
import Loading from "../../common/Loading";
import {toast} from 'react-toastify'
const ClinicInfo = () => {
  const [clinic, setClinic] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { clinicId } = useParams();

  useEffect(() => {
   
    try{
        setIsLoading(true)
        clinicService.getClinicById(clinicId).then((res) => {
            
            setClinic(res.data)
            setIsLoading(false)
          });
    } catch(err){
        setIsLoading(false)
    }
    
  }, [clinicId]);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="container container-xxl">
          <div className="pagetitle d-flex justify-content-between">
            <h1><i className="bi bi-hospital"></i> {clinic && clinic.name}</h1>
              <Link to="/clinics" className="btn btn-sm btn-outline-secondary">
                  <i className="bi bi-chevron-left me-1"></i> Back
              </Link>
          </div>
          <section className="section clinicinfo contact">
           
            <div className="row">
             
             <div className="col-12">
               <div className="card">
                 <div className="card-body pt-3">
                    <ClinicTabContainer />
                 </div>
               </div>
             </div>
           </div>
           
           
          </section>
        </div>
      )}
    </>
  );
};

export default ClinicInfo;
